// extracted by mini-css-extract-plugin
export default {"overlay":"IA-z","bodyOpen":"JA-z","content":"KA-z","header":"LA-z","closeNoHeading":"MA-z"};